import { Component } from '@angular/core';
import { GraphService } from '../../General/graph/graph.service';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { GraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/graph-exercise.component';
import { GraphUU } from '../../shared/interactive-graph/simple_graphs/graphUU';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';
import { GraphAlgorithm, Interactable } from 'graph-interactive';
import { InteractionType } from 'graph-interactive/dist/lib/interactive/InteractionType';
import { AbstractEdge } from 'graph-interactive/dist/lib/abstract/aEdge';

@Component({
  selector: 'app-vertex-cover',
  templateUrl: './vertex-cover.component.html',
  styleUrls: ['./vertex-cover.component.css']
})
export class VertexCoverComponent extends GraphExerciseComponent {


  private readonly resetPathID: string = 'resetPathButton';
  private readonly canvasID: string = 'graph-canvas';



  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService,
    protected messageService: MessageService, graphService: GraphService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
    this.type = 'vertexCover';
  }

  initGraph(): InteractiveGraph{
    const canvas = <HTMLCanvasElement>document.getElementById(this.canvasID); //Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized
    let graph = new VCGraphUU(canvas);
    graph.setInteractionType(InteractionType.HIGHLIGHT_VERTEX_COVER);
    return graph;
  }

  ngOnInit() {
    super.ngOnInit();
    window.onload = function () { };
    const resetPathButton = <HTMLButtonElement>document.getElementById(this.resetPathID);
    resetPathButton.addEventListener('click', this.onResetSelection, false);
  }

  onResetSelection = () =>{
    this.graph.resetSelected();
    this.graph.forceUpdate();
  }
  
  

  checkSolution() {
    let ev = this.evaluate();
    if(ev[0] == ev[1]){
      this.messageService.addAlertWithTimeout(this.get('success'), 'success', 10000);
      this.messageService.addAlertWithTimeout(this.get('FoundVertexCover'), 'success', 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    }
    else {
      this.messageService.addAlertWithTimeout(this.get('NotFoundVertexCover'), 'danger', 10000);
    }
  }

  setTypeSpecificsFromState() {
  }



  computeState() {
    //Nothing to store
  }

  resetState() {
    this.graph.resetSelected();
    super.resetState();
  }


  setTypeSpecificsFromConfiguration() {
    window.onload = function () { };
  }

  evaluate(): [number, number] {
    let expected = GraphAlgorithm.vertexCover(this.graph.getGraph()).length;
    if(!GraphAlgorithm.isVertexCover(this.graph.getSelectedNodes(), this.graph.getGraph())){
      return [0,1];
    }
    let point: number = (expected >= this.graph.getSelectedNodes().length) ? 1: 0;
    return [point,1];
  }
}


//Specific graph for making edges non interactable
class VCGraphUU extends GraphUU {
  disableHover(interactabe: Interactable): boolean {
    if (interactabe instanceof AbstractEdge) {
      return true;
    }
    return super.disableHover(interactabe);
  }

}
